import ReducerBuilder from 'classes/ReducerBuilder';
import initialState from './initialState';
import {Types} from './actions';

const reducer = ReducerBuilder.make(initialState)
    .forType(Types.EXPAND_ROW)
    .reduce((state, action) => {
      state.currentExpandedRow = action.row;
      return state;
    })
    .forType(Types.COLLAPSE_ROW)
    .reduce((state, action) => {
      state.currentExpandedRow = null;
      return state;
    })
    .build();

export default reducer;



// WEBPACK FOOTER //
// ./public/pages/ListBreaks/reducer.js